<!-- 推广账户管理 - 百度 -->
<template>
<div>
	<div style="display: flex;align-items: center;">
		<div v-for="(item,index) in titleTab" :key="index" 
		:class="{'title-tab-box-selected': item.select}" 
		@click="changeTab(item,index)"
		class="title-tab-box">{{item.label}}</div>
	</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;">
		<div v-show="content_type == 0" class="screen-box">
			<div class="screen-label">推广账户名称</div>
			<a-input v-model="r_bd_user_name" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<div v-show="content_type == 0" class="screen-box">
			<div class="screen-label">负责人</div>
			<adminSelect @handleChangeSelect="handleChangeF"></adminSelect>
		</div>
		
		<div v-show="content_type == 1" class="screen-box">
			<div class="screen-label">管家账户名称</div>
			<a-input v-model="r_bd_gj_name" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
		<a-button v-show="content_type == 0" @click="showPlAccID()" class="screen-box" type="primary">批量搜索账户ID</a-button>
		<a-button v-show="content_type == 0" class="screen-box" @click="setFZR" type="primary">批量设置负责人（已选{{selectedData.length}}项）</a-button>
		
		<a-button v-show="content_type == 0" class="screen-box" @click="SQaccount" type="primary">授权推广账户</a-button>
		
		<!-- <a-button  v-show="content_type == 0" @click="addButton" class="screen-box" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增推广账户</a-button>
		<a-button  v-show="content_type == 1" @click="addButton" class="screen-box" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增开发者账户</a-button> -->
	</div>
	
	<div v-show="content_type == 0">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell"
			:style="{'width':60 + 'px'}">
				<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- 选择 -->
			<div class="table-td-cell" :style="{'width':60 + 'px'}">
				<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
			</div>
			
			<!-- 推广账户名称 -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.bd_user_name}}
			</div>
			<!-- 推广账户ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.bd_user_id}}
			</div>
			<!-- a_key -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}"  @click="setA_key(item)" style="color: #62a8ea;cursor: pointer;">
				<div v-if="item.akey">{{item.akey}}</div>
				<div v-else>未设置</div>
			</div>
			<!-- 负责人 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				<div @click="TdShowFZR(item)" v-if="item.auth.length > 0" style="display: flex;align-items: center;cursor: pointer;">
					<div v-for="(item,index) in item.auth" :key="index" style="color: #2F88FF;margin: 0 10px 5px 0">
						{{item.admin_name}}
					</div>
				</div>
				<div @click="TdShowFZR(item)" v-else style="color: #62a8ea;cursor: pointer;">
					未设置
				</div>
			</div>
			<!-- 管家账户 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.admin_account_name}}
			</div>
			
		</div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	<div v-show="content_type == 1">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width_d + 'px'}">
			<div  v-for="(item,index) in rableTitleDDD" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowDataDDD" :key="index" class="table-td"  :style="{'width': table_scroll_width_d + 'px'}">
			<!-- 管家账户名称 -->
			<div class="table-td-cell" :style="{'width':rableTitleDDD[0].width + 'px'}">
				{{item.bd_user_name}}
			</div>
			<!-- 管家账户ID -->
			<div  class="table-td-cell" :style="{'width':rableTitleDDD[1].width + 'px'}">
				{{item.bd_user_id}}
			</div>
			
			<!-- 操作 -->
			<div  class="table-td-cell" :style="{'width':rableTitleDDD[2].width + 'px'}">
				<div @click="syncButton(item)" style="color: #62a8ea;cursor: pointer;">同步推广账户</div>
			</div>
			
		</div>
		
		<div v-show="tableShowDataDDD.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width_d + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<div style="text-align: center;margin-top: 30px;" :style="{'width': table_scroll_width_d + 'px'}">
			
			<a-pagination v-model="d_page" :pageSize="20" :total="table_total_ddd" @change="paginationChange" />
			
		</div>
	</div>
	
	<!-- 批量设置负责人 -->
	<a-modal :visible="pl_modal" title="批量设置负责人" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的负责人</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择负责人"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
					:value="fzr_user"
				  >
					<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 120px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 15px;">{{item.label}}</div>
					<!-- <div @click="delSelectFZR(index)" style="color: red;cursor: pointer;">删除</div> -->
					<a-icon @click="delSelectFZR(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的推广账户名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 105px;">{{item.bd_user_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      title="设置a_key"
	      :visible="edit_visible"
	      :confirm-loading="confirm_loading"
		  cancelText="取消"
		  okText="确认" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
	    >
		<a-input v-model="e_akey" placeholder="请输入a_key" style="width: 360px;"  />
	</a-modal>
	
	<!-- 批量搜索账户ID -->
	<plSearchID ref="refPlSearchID" @get-pl-id="getPlId"></plSearchID>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import plSearchID from "./components/plSearchID"
import adminSelect from "./components/adminSelect"
import { accBaiduAdvList, putUserList, accBDSetAdvUser, accBDAuthList, accBDsync, accBDa_key } from '@/request/api'
export default {
	name: 'accountBD_',
	components: {
		plSearchID,adminSelect
	},
	data() {
		return {
			titleTab: [
				{label: "推广账户管理", select: true , value: 0 },
				{label: "管家账户管理", select: false , value: 1 },
			],
			content_type: 0, // 页面内容展现类型
			
			r_bd_user_name: "",
			r_bd_gj_name: "",
			r_page: 1,
			r_limit: 20,
			r_admin_id: null, // 负责人id
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"推广账户名称", width:200, type:"bd_user_name", },
				{title:"推广账户ID", width:200, type:"bd_user_id", },
				{title:"a_key", width:200, type:"a_key", },
				{title:"负责人", width:180, type:"auth", },
				{title:"管家账户", width:260, type:"admin_account_name", },
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1000,
			table_scroll_width_d: 1000,
			search_button_loading: false,
			table_total: 0,
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量设置负责人
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			
			personChargeList: {}, // 负责人列表
			
			rableTitleDDD: [
				{title:"管家账户名称", width:200, type:"advertiser_name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"管家账户ID", width:260, type:"advertiser_id", },
				{title:"操作", width:160, type:"cz", },
			],
			tableShowDataDDD: [],
			table_total_ddd: 0,
			d_page: 1,
			
			// 编辑单项弹窗
			edit_visible: false,
			confirm_loading: false,
			e_akey: "",
			e_id: "",
			
			// 批量搜索账户ID
			pl_text_content: [], // 批量粘贴过来，分隔过后的数据
			
			fzr_user: undefined,
		}
	},
	mounted(){
		let that = this
		
		// let nn = 0
		// that.rableTitle.forEach((res,index)=>{
		// 	nn = nn + res.width
		// })
		// that.table_scroll_width = nn + 60
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		let table_info_c = this.$getTableInfo(that.rableTitleDDD)
		that.table_scroll_width = table_info.table_width
		that.table_scroll_width_d = table_info.table_width
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
		
		// accBDAuthList({
		// 	limit: that.r_limit,
		// 	page: that.d_page,
		// 	bd_user_name: that.r_bd_gj_name
		// }).then(res=>{
		// 	console.log("管家",res);
		// })
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 负责人
		handleChangeF(e){
			this.r_admin_id = e
		},
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				this.r_page = 1
				this.searchButton()
			}
		},
		
		searchButton(type){
			let that = this
			
			that.search_button_loading = true
			if(that.content_type == 0){ // 推广账户管理
				if(type == 'button'){
					that.r_page = 1
				}
				let r_data = {
					limit: that.r_limit,
					page: that.r_page,
					bd_user_name: that.r_bd_user_name,
					
					admin_id: that.r_admin_id, // 负责人id
				}
				if(type == '批量账户ID'){
					r_data.adv_id = that.pl_text_content
				}
				
				if(type == 'button' || type == '批量账户ID'){
					that.selectedData = []
				}
				
				accBaiduAdvList(r_data).then(res=>{
					console.log("搜索",res);

					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						let data = res.data.data.data || []
						data.forEach(res=>{
							res.checked = false // 用于多选和单选
						})
						
						if(that.selectedData.length > 0){
							let ccc = true
							let iii = 0 // 用于判断是否全选
							data.forEach(res=>{
								that.selectedData.forEach(res_r=>{
									if(res.id === res_r.id){
										res.checked = true
										ccc = false
										iii = iii + 1
									}
								})	
							})
							console.log("iii",iii)
							if(iii === 20){ // 全选
								that.indeterminate = false
								that.checkAll = true
							}
							else {
								if(ccc){
									that.checkAll = false
									that.indeterminate = false
								}
								else {
									that.checkAll = false
									that.indeterminate = true
								}
							}
							
						}
						else {
							console.log("that.checkAll",that.checkAll)
							that.checkAll = false
							that.indeterminate = false
							data.forEach(res=>{
								res.checked = false
							})
						}
						
						that.search_button_loading = false
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = data
					}
					else {
						that.search_button_loading = false
						that.checkAll = false
						that.indeterminate = false
						that.selectedData = []
						that.tableShowData.forEach(res=>{
							res.checked = false
						})
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(that.content_type == 1){ // 管家账户管理
				accBDAuthList({
					limit: that.r_limit,
					page: that.d_page,
					bd_user_name: that.r_bd_gj_name
				}).then(res=>{
					console.log("管家",res);
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total_ddd = res.data.data.total
						that.tableShowDataDDD = res.data.data.data
					}
					else {
						
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		
		// 分页
		paginationChange(e){
			let that = this
			if(that.content_type == 0){ // 推广账户管理
				that.r_page = e
			}
			else if(that.content_type == 1){ // 管家账户管理
				that.d_page = e
			}
			that.searchButton()
			
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		TdShowFZR(e){
			console.log(e);
			let that = this
			e.auth.forEach(res=>{
				let obj = {
					key: res.admin_id,
					label: res.admin_name
				}
				that.pl_select_admin.push(obj)
			})
			
			that.selectedData.push(e)
			
			that.pl_modal = true
		},
		// 批量设置负责人
		handleChangeD(e){
			console.log(e);
			this.fzr_user = e
			
			let ttt = true
			// 去重
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		// 批量设置负责人
		setFZR(){
			if(this.selectedData.length > 0){
				this.pl_modal = true
			}
			else {
				this.$message.warning('请先选择内容');
			}
		},
		// 批量设置负责人
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择设置负责人
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.bd_user_id)
				})
				console.log("i_data",i_data);
				
				accBDSetAdvUser({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置设置负责人",res);
					that.selectedData = []
					that.plCancel()
					that.$message.success('设置成功');
					that.searchButton()
				})
			}
			else {
				this.$message.warning('请先选择设置负责人');
			}
			
			
		},
		// 批量设置管理员弹窗取消按钮
		plCancel(){
			// if(this.pl_loading){
			// 	return 
			// }
			this.pl_modal = false
			this.pl_select_admin = []
			this.pl_loading = false
			
			this.fzr_user = undefined
		},
		// 删除选择的负责人
		delSelectFZR(index){
			this.pl_select_admin.splice(index,1)
		},
		
		// 授权推广账户
		SQaccount(){
			let that = this
			this.$confirm({
			    title: '添加推广账户',
			    content: "点击确认打开新网页进行授权，授权成功后请刷新页面",
				okText: '确认',
				cancelText: '取消',
			    onOk() {
			      window.open(`${that.$http.open_url}api/account/baidu-oauth-account`)
			    },
			    onCancel() {
			      console.log('Cancel');
			    },
			});
		},
		
		
		// 同步推广账户
		syncButton(e){
			let that = this
			accBDsync({
				bd_user_id: e.bd_user_id
			}).then(res=>{
				console.log("同步推广账户",res)
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('操作成功');
				}
				else {
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		
		// 设置a_key
		setA_key(e){
			console.log("a_key",e);
			this.e_id = e.id
			this.e_akey = e.akey
			this.edit_visible = true
			
		},
		editModalOk(){
			let that = this
			if(!that.e_akey){
				that.$message.warning('内容不能为空');
			}
			else {
				that.confirm_loading = true
				accBDa_key({
					id: that.e_id,
					akey: that.e_akey,
				}).then(res=>{
					console.log("设置a_key",res);
					that.confirm_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.editModalCancel()
						that.$message.success('设置成功');
						that.searchButton()
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		editModalCancel(){
			this.e_akey = ""
			this.edit_visible = false
		},
		
		
		showPlAccID(){
			this.$refs.refPlSearchID.plAccountID()
		},
		getPlId(ttt){
			this.pl_text_content = ttt
			this.searchButton('批量账户ID')
		}
	}
}
</script>

<style>
</style>